module.exports = __webpack_public_path__ + "img/添加备注.6abd0e8c.png";